import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import '@web/shared-digital-library/icons/svg-originals/bag.svg';
import CategoryStickyButtons from '~/components/organisms/Category/CategoryStickyButtons.vue';
import { extractSelectedFilters } from '~/helpers/extract-helper';
import marketClosed from '~/helpers/marketClosed';
var MdmLink = function MdmLink() {
  return import('~/components/atoms/MdmLink.vue');
};
var SearchItem = function SearchItem() {
  return import('~/components/specific/TheHeader/Menu/SecondaryNav/Items/SearchItem.vue');
};
export default {
  name: 'BannerMobile',
  components: {
    SearchItem: SearchItem,
    CategoryStickyButtons: CategoryStickyButtons,
    MdmLink: MdmLink
  },
  props: {
    cartUrl: {
      type: String,
      default: ''
    },
    homeUrl: {
      type: String,
      default: ''
    },
    accountUrl: {
      type: String,
      default: ''
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpenMenu: false,
      search: '',
      isOpen: false,
      isSearchOpen: false,
      showFiltersButtons: false,
      selectedLayer: null,
      filters: null,
      showStickyFilters: null,
      scrollUp: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    total: 'cart/total',
    user: 'user/me',
    locale: 'i18n/locale',
    searchDescription: 'search/description',
    description: 'category/description',
    filterBy: 'pageActions/filterBy'
  })), {}, {
    htmlClasses: function htmlClasses() {
      var classes = ['global-wrapper'];
      if (this.isOpen) {
        classes.push('active-mobile');
      }
      return classes.join(' ');
    },
    activeStickyFilters: function activeStickyFilters() {
      return Boolean(this.$cookies.get('category-sticky-buttons'));
    },
    isMarketOpen: function isMarketOpen() {
      if (!this.locale) return true;
      var market = this.locale.market;
      return !marketClosed({
        market: market
      });
    }
  }),
  watch: {
    $route: function $route() {
      var isCategoryRoute = this.$route.path.includes('/c/');
      var isKeywordRoute = this.$route.path.includes('/q/');
      if (this.activeStickyFilters && (isCategoryRoute || isKeywordRoute)) {
        this.showFiltersButtons = true;
      } else if (this.activeStickyFilters && (!isCategoryRoute || !isKeywordRoute)) {
        this.showStickyFilters = false;
        this.scrollUp = false;
        this.showFiltersButtons = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.isCategoryTemplate() || this.isKeywordTemplate()) {
      this.$root.$on('sticky-filters-button', function (scrollReachedLimit, scrollUp) {
        _this.showFiltersButtons = scrollReachedLimit;
        _this.showStickyFilters = scrollReachedLimit;
        _this.scrollUp = scrollUp;
      });
    }
    this.$root.$on('open-search-mobile', function () {
      _this.isSearchOpen = true;
    });
    this.$root.$on('close-search-mobile', function () {
      _this.isSearchOpen = false;
    });
    this.$root.$on('closeMenu', function (shouldChange) {
      if (shouldChange === false) return;
      _this.closeMenu();
    });
  },
  methods: {
    selectedFilters: function selectedFilters() {
      if (this.isCategoryTemplate() && this.filterBy && this.description) {
        return extractSelectedFilters(this.filterBy, this.description.filters);
      }
      if (this.isKeywordTemplate() && this.filterBy && this.searchDescription) {
        return extractSelectedFilters(this.filterBy, this.searchDescription.filters);
      }
      return [];
    },
    isCategoryTemplate: function isCategoryTemplate() {
      return this.$route.path.includes('/c/');
    },
    isKeywordTemplate: function isKeywordTemplate() {
      return this.$route.path.includes('/q/');
    },
    closeSearch: function closeSearch() {
      this.isOpenMenu = false;
    },
    tracking: function tracking(evt, data) {
      this.$root.$emit('generic-tracking', evt, {
        data: _objectSpread({
          event_category: 'Header',
          event_action: '',
          event_label: ''
        }, data)
      });
    }
  },
  head: function head() {
    return {
      htmlAttrs: {
        class: this.htmlClasses
      }
    };
  }
};